import React from "react";
import { createBadgePipeline } from "./badgePipeline";
import { RenderBadgesProps } from "./renderBadgesTypes";

export const renderBadges = (
  props: RenderBadgesProps,
): React.ReactElement[] => {
  const pipeline = createBadgePipeline(props.type, props.badgesByProduct || []);

  return pipeline.process({
    uuid: props.uuid,
    monarchBadges: props.monarchBadges,
    popularItemList: props.popularItemList,
    programType: props.programType,
    microDegreeTag: props.microDegreeTag,
    type: props.type,
    popularBadgeOverride: props.popularBadgeOverride,
  });
};
